import React, { Component } from "react";

import { Form, Button, Input, Checkbox, Row, Col, Spin } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import VehicleGroupStore from "../store/VehicleGroupStore";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";

import CompanyStore from "../store/CompanyStore";

const CheckboxGroup = Checkbox.Group;

class VehicleGroupAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showAsset: false,
      selectedChecked: false,
      selectedValues: [],
      deviceGroupId: "",
      companyId: "",
      loadingSpin: false,
    };
    this.groupStore = new VehicleGroupStore();
    this.companyStore = new CompanyStore();
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ isadmin: this.props.getUserData().isadmin });
      await this.groupStore.getAssetData(
        this.props.getUserData().userCompanyId
      );

      await this.setState({ update: 1 });
    }
    const deviceGroupId = this.props.vehicleGroupId;

    if (deviceGroupId) {
      await this.filldata(deviceGroupId);
      await this.setState({ deviceGroupId: deviceGroupId });
    }
  }

  filldata = async (deviceGroupId) => {
    await this.setState({ loadingSpin: true });
    const getVehicleGroup = await this.groupStore.getVehicleGroupData(
      deviceGroupId,
      this.props.companyId
    );

    const allVehicles = await this.groupStore.getAssetData(
      this.props.companyId
    );

    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );

    await this.setState({
      companyId: getVehicleGroup.companyId,
      deviceGroupId: getVehicleGroup.deviceGroupId,
    });

    // const vehicles =await this.groupStore.vehicleArray
    // console.log(vehicles)
    let vehicleData = [];
    getVehicleGroup.vehicles?.forEach((val) => {
      vehicleData.push(val.vehicleId);
    });
    if (vehicleData.length === allVehicles.length) {
      this.setState({ selectedChecked: true });
    }

    await this.setState({ selectedValues: vehicleData });

    await this.formRef.current.setFieldsValue({
      deviceGroupId: getVehicleGroup.deviceGroupId,
      companyId: singleData,
      groupname: getVehicleGroup.groupname,
      inchargeName: getVehicleGroup.inchargeName,
      email: getVehicleGroup.email,
      // vehicle: this.state.selectedValues,
    });
    await this.setState({ loadingSpin: false });
  };
  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  onDeviceDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    const data = {
      ...values,
      companyId: this.state.companyId,
      devicegroupId: this.state.deviceGroupId,
      deviceGroupparentId: 0,
      // devicegroupId: "",
      tokenId: "",
      vehicle: this.state.selectedValues,
    };

    const resp = await this.groupStore.addData(data);
    await this.props.response(resp);

    this.setState({ loading: false });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      console.log(this.props.vehicleGroupId, "EDITRRRRR");

      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }

    await this.formRef.current.setFieldsValue({
      companyId: this.state.companyId,
    });

    await this.groupStore.getAssetData(this.state.companyId);

    await this.handleSearch();
  }

  async handleSearch() {
    await this.groupStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  handleSelectAllChange = async (e) => {
    this.setState({ selectedChecked: e.target.checked });

    if (e.target.checked) {
      const allValues = this.groupStore?.assetList.map(
        (option) => option.vehicleId
      );
      this.formRef.current.setFieldsValue({ vehicle: allValues.vehicleNo });

      await this.setState({ selectedValues: allValues });

      console.log(allValues);
    } else {
      await this.setState({ selectedChecked: e.target.checked });
      await this.setState({ selectedValues: [] });
    }
  };

  handleCheckboxChange = async (checkedValues) => {
    if (checkedValues?.length === this.groupStore.assetList.length) {
      console.log("hoo");
      await this.setState({ selectedChecked: true });
    } else {
      await this.setState({ selectedChecked: false });
    }
    await this.setState({ selectedValues: checkedValues });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ height: "100%", paddingBottom: "10px" }}>
          <Spin
            spinning={this.state.loadingSpin}
            wrapperClassName="spinClass"
            fullscreen
          >
            <Form
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onDeviceDetailsSubmit}
              name="nest-message"
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      className="uploadCompany"
                      name="companyId"
                      // label={this.context.translate("_ACCOUNT_")}
                      // rules={[{ required: true }]}
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_ACCOUNT_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <CompanyAutocomplete
                        value={this.state.companyId}
                        onChange={(value) => this.handleChange(value)}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    className="uploadCompany"
                    name="groupname"
                    // label={this.context.translate(
                    //   "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                    // )}
                    // rules={[{ required: true }]}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="inchargeName"
                    label={this.context.translate("_INCHARGE_NAME_")}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} className="formColumnClass">
                  <Form.Item
                    className="uploadCompany"
                    name="email"
                    label={this.context.translate("_EMAIL_")}
                    rules={[
                      {
                        type: "email",
                        message: this.context.translate("_INVALID_EMAILID_"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item label=" ">
                    {this.context.translate(
                      "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                    )}
                    &nbsp;&nbsp;
                    <Checkbox
                      checked={this.state.selectedChecked}
                      onChange={(e) => {
                        this.handleSelectAllChange(e);
                      }}
                    >
                      {this.context.translate("_ALL_")}
                    </Checkbox>
                  </Form.Item>
                  <CheckboxGroup
                    name="vehicle"
                    value={this.state.selectedValues}
                    onChange={this.handleCheckboxChange}
                  >
                    <Row>
                      {this.groupStore?.assetList?.map((value) => {
                        return (
                          <Col span={12}>
                            <Checkbox
                              key={value.vehicleId}
                              value={value.vehicleId}
                            >
                              {value.vehicleNo}
                            </Checkbox>
                          </Col>
                        );
                      })}
                    </Row>
                  </CheckboxGroup>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.closeModal();
                    this.setState({
                      selectedChecked: false,
                      selectedValues: [],
                    });
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                  loading={this.state.loading}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

VehicleGroupAdd.contextType = StoreContext;
export default observer(withRouter(VehicleGroupAdd));
